var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.is_h5_home)?_c('div',[_c('PageHeaderMobile'),(_vm.pageHeaderShow && !_vm.vuex_h5)?_c('PageHeader'):_vm._e(),(_vm.navShow && !_vm.vuex_h5)?_c('Nav'):_vm._e()],1):_vm._e(),_c('div',{staticClass:"main-box"},[_c('router-view')],1),(_vm.is_h5_home)?_c('PageFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }